import { useQuery as useApolloQuery } from '@apollo/react-hooks';

const useQuery = (...args) => (
  useApolloQuery(...args)
);

export default useQuery;
